<script>
    import Vue from "vue";

    export default {
        name: 'MailsImportApp',
        data: function() {
            return {
                locked: false,
                picked: {},
                disallowed: {},
            }
        },
        mounted: function() {
            let ap = this;
            this.$el.dataset.mapping.split(',').forEach(function(val, idx){
                Vue.set(ap.picked, String(idx), val);
            })
        },
        methods: {
            updatePicked: function(key, event){
                Vue.set(this.picked, key, event.target.value);
            }
        }
    }
</script>
